import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { backgroundColors, spacing } from 'ui/theme';
import { FullWidth } from 'ui/utility/fullWidth';

export const SegmentationPageContainer = styled(FullWidth)<{ navBarHeight: number }>`
  background-color: ${backgroundColors.backgroundSecondary};
  display: flex;
  flex-direction: column;
  min-height: ${({ navBarHeight }) =>
    `calc(100vh - (${pxToRem(navBarHeight)} + ${spacing.layoutTopPadding}))`};
`;
